import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaMetadataMenuRegistry = {
    personalize_nebulaMetadata: {
        label: "Nebula Metadata",
        link: PAGE_URL.NEBULA_METADATA_PAGE,
        key: PAGE_URL.NEBULA_METADATA_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaMetadataMenuRegistry;
